<template>
	<div class="container">
		<h1>Checkout</h1>

		<div v-if="loading">Please wait...</div>

		<ux-form v-else ref="form">
			<div class="row">

				<!-- ADDRESS / PAYMENT INFO -->
				<div class="col-md-6">
					<div class="text-subtitle mb-6">Add Coupon</div>
					<promo-code-entry />

					<div class="text-subtitle mb-6">Shipping Address</div>
					<address-selector address-type="shipping" />

					<div v-if="summary.total > 0">
						<div class="text-subtitle mb-6">Payment Method &amp; Billing Address</div>
						<payment-method-selector ref="paymentMethod" />
					</div>
				</div>

				<!-- ORDER ITEM DETAILS -->
				<div class="col-md-6">
					<div class="text-subtitle mb-6">Order Overview</div>
					<cart-items />
				</div>
			</div>
		</ux-form>
		
		<ul class="ux-btn-list is-horz">
			<li class="fill-space"><ux-btn color="outline-primary" href="/categories" :disabled="submitting">Continue Shopping</ux-btn></li>
			<li><ux-btn color="primary" @click.prevent="submit" :loading="submitting">Submit Order</ux-btn></li>
		</ul>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import store from 'frontend/store';
import alerts from 'common/alerts';

import AddressSelector from './AddressSelector.vue';
import PaymentMethodSelector from './PaymentMethodSelector.vue';
import CartItems from './CartItems.vue';
import PaymentForm from './PaymentForm.vue';
import PromoCodeEntry from './PromoCodeEntry.vue';

export default {
	components: { AddressSelector, CartItems, PaymentForm, PromoCodeEntry, PaymentMethodSelector },

	data()
	{
		return {
			loading: true,
			submitting: false,
		}
	},

	computed: {
		...mapState({
			currentUser: state => state.shell.currentUser,
			order: state => state.checkout.order,
			summary: state => state.checkout.summary,
		})
	},

	methods: {
		...mapMutations('checkout', ['resetOrder', 'updateOrder']),

		async load()
		{
			this.loading = true;

			try
			{
				await this.$store.dispatch('addresses/fetchUserAddresses');
				await this.$store.dispatch('paymentMethods/fetchMethodList');
				//await this.$store.dispatch('addresses/fetchSummary');
			}
			finally
			{
				this.loading = false;
			}
		},

		async submit()
		{
			if (!this.$refs.form.validate()) {
				return;
			}

			this.submitting = true;

			try
			{
				var result;

				if (this.summary.total > 0 && this.order.paymentMethod.is_new)
				{
					var { nonce, cardData } = await this.$refs.paymentMethod.getNonce();
					var method = { ...this.order.paymentMethod, card_token: nonce };
					
					method.billing_addr = { ...method.billing_addr, postal_code: cardData.billing.postalCode };
					
					this.updateOrder({ paymentMethod: method });
				}
				
				result = await this.$store.dispatch('checkout/submitOrder');

				await alerts.show('Order submitted successfully!', 'Success', 'success');

				document.location = `/profile/order/${result.order_id}`;
			}
			catch(err)
			{
				console.log(err);
			}
			finally
			{
				this.submitting = false;
			}
		}
	},

	mounted()
	{
		this.resetOrder();
		this.load();
	},

	// users must be logged in to view this screen
	beforeRouteEnter(to, from, next)
	{
		if (store.state.shell.currentUser == null)
			document.location = '/login?redirect=%2Fcheckout';
		else
			next();
	},

	beforeRouteUpdate(to, from, next)
	{
		if (this.currentUser == null)
			document.location = '/login?redirect=%2Fcheckout';
		else
			next();
	}
}
</script>